import request from './HttpService';
import { ENDPOINTS } from '../utils/constants';

export interface OrderUpdate {
  actionType: string;
  orderNumber: string;
  vin: string;
  requestor: string;
  retry?: boolean;
}

export const getVehicleOrder = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.vehicleOrderInfo(reservationId));
  return response.data.data;
};

export const updateOrder = async (data: OrderUpdate) => {
  const response = await request.post(ENDPOINTS.releaseOrCancelOrder, data);
  return response.data;
};

export default { getVehicleOrder, updateOrder };
